import { useCallback } from 'react';
import { messages } from '../../../common/messages';
export const useComponentFunctionsManager = (apiContext, waitUntilReady) => {
  const handleInvokeFunction = useCallback(async (definition, fnName, args) => {
    const componentNameDefPair = Object.entries(apiContext.current.configSpec).find(([__name, componentDef]) => componentDef === definition);
    if (!componentNameDefPair) {
      throw new Error(`Component not found.`);
    }
    const [componentName] = componentNameDefPair;
    await waitUntilReady(componentName);
    const context = apiContext.current.iframeContextMap[componentName];
    if (context) {
      context.sendMessage(messages.INVOKE_FUNCTION, {
        fnName,
        args,
        target: componentName
      });
    }
  }, [apiContext, waitUntilReady]);
  return {
    handleInvokeFunction
  };
};